<template>
  <div id="wrapper">
    <router-view></router-view>
    <transition-group name="expand">
      <template v-for="(modal, index) in modals">
        <modal-form v-if="modal.permalink"
          :key="index"
          :permalink="modal.permalink"
          :data="modal.data"
          :options="modal.options"
          :params="modal.params"
          :index="index"
          @change="update(modal.data, $event)">
        </modal-form>
        <modal-alert v-else-if="modal.alertUuid"
          :alertUuid="modal.alertUuid"
          :key="index"
          @dismiss="closeModal(index)"
          :is-open="true"
          :data="modal.data">
        </modal-alert>
        <modal v-else-if="!modal.alreadyOpen"
          :is-open="true"
          :options="modal.options"
          :title="modal.title"
          :key="index">
          <div v-html="modal.html"></div>
          <div slot="footer">
            <button type="button" class="btn btn-default"
              @click="closeModal(index)">
              Dismiss
            </button>
          </div>
        </modal>
      </template>
    </transition-group>
    <div class="modal-backdrop fade show" v-show="modals.length"></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ModalForm from '@/components/ModalForm'
import ModalAlert from '@/components/ModalAlert'
import Modal from '@/components/Modal'
import dom from '@/util/dom'
import { REFRESH_LOGGED_IN_USER, LOAD_SIDEBAR } from '@/vuex/types'

export default {
  name: 'App',
  components: {
    Modal,
    ModalForm,
    ModalAlert
  },
  computed: {
    ...mapGetters([
      'modals',
      'isLoggedIn',
      'loggedInUser'
    ])
  },
  data () {
    return {
      fromPath: '/',
      failedLogin: false
    }
  },
  mounted () {
    this.checkLoginStatus(this.isLoggedIn)
  },
  watch: {
    $route () {
      this.$store.dispatch(LOAD_SIDEBAR)
    },
    modals ({ length }) {
      if (length > 0) {
        dom(this.$root.$el.parentElement).addClass('modal-open')
      } else {
        dom(this.$root.$el.parentElement).removeClass('modal-open')
      }
    },
    isLoggedIn (loggedIn) {
      this.checkLoginStatus(loggedIn)
    }
  },
  methods: {
    async checkLoginStatus (loggedIn) {
      if (!loggedIn && this.$router.currentRoute.path !== '/login') {
        this.fromPath = this.$router.currentRoute.fullPath
        this.failedLogin = true
        this.$router.push('/login')
      } else if (loggedIn && this.fromPath !== '/') {
        let redirect = this.fromPath
        this.fromPath = '/'
        await this.$nextTick()
        this.$router.replace(redirect)
      } else if (loggedIn && !this.loggedInUser.uuid) {
        await this.$store.dispatch(REFRESH_LOGGED_IN_USER)
      }
    },
    ...mapMutations([
      'closeModal'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue